import React from 'react';
import { Icon } from './Icon.js';
export const IconImageMountain2Fill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("circle", { cx: "2.75", cy: "2.75", r: "1.75", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("path", { d: "m11.022,9.14l-1.463-4.635c-.142-.448-.494-.798-.943-.936-.447-.139-.938-.048-1.308.244,0,0,0,0,0,0L1.454,8.449c-.484.383-.666,1.007-.463,1.59.202.584.732.961,1.351.961h7.317c.454,0,.886-.219,1.154-.585.268-.366.346-.843.209-1.275Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconImageMountain2Fill12.js.map